__turbopack_context__.v({
  "rainCanvas": "Rain-module__fnMdXG__rainCanvas",
  "rainCanvasWrapper": "Rain-module__fnMdXG__rainCanvasWrapper",
});
